import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const agencyServiceApi = createApi({
  reducerPath: 'agencyServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetDataOrigin: builder.query<any, void>({
      query: () => 'agency/dataorigin',
    }),
    GetAgency: builder.query<any, void>({
      query: () => 'agency/',
    }),
    GetAgencyStop: builder.query<any, void>({
      query: (id) => `agency/stops/${id}`,
    }),
    GetAgencyStopLines: builder.query<any, void>({
      query: (id) => `agency/stops/${id}/lines`,
    }),
    GetAgencyStopLinesTimes: builder.query<any, void>({
      query: (id) => `agency/stops/${id}/timestr`,
    }),
    GetAgencyStopLinesChild: builder.query<any, void>({
      query: (id) => `agency/stops/${id}/lines-of-childs`,
    }),
  }),
});

export const {
  useLazyGetDataOriginQuery,
  useLazyGetAgencyQuery,
  useLazyGetAgencyStopQuery,
  useLazyGetAgencyStopLinesQuery,
  useLazyGetAgencyStopLinesTimesQuery,
  useLazyGetAgencyStopLinesChildQuery,
} = agencyServiceApi;
